import React from 'react';
import classNames from 'classnames';

export const HeaderTitle: React.FC = ({ children }) => {
  return <h1 className={classNames('header-title pt-5 pb-3 didAppear px-2 px-lg-0')}>{children}</h1>;
};
